export default [
  { value: 'Interior', label: 'Interior' },
  { value: 'Exterior', label: 'Exterior' },
  { value: 'Data Entry', label: 'Data Entry' },
  { value: 'Condition Report', label: 'Condition Report' },
];
